export default "__VITE_ASSET__d0d24182__"